import { render, staticRenderFns } from "./StoreControl.vue?vue&type=template&id=3697fdd4&scoped=true"
import script from "./StoreControl.vue?vue&type=script&lang=ts"
export * from "./StoreControl.vue?vue&type=script&lang=ts"
import style0 from "./StoreControl.vue?vue&type=style&index=0&id=3697fdd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3697fdd4",
  null
  
)

export default component.exports